import { render, staticRenderFns } from "./TagInput.vue?vue&type=template&id=289610f1&scoped=true&"
import script from "./TagInput.vue?vue&type=script&lang=js&"
export * from "./TagInput.vue?vue&type=script&lang=js&"
import style0 from "./TagInput.vue?vue&type=style&index=0&id=289610f1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "289610f1",
  null
  
)

export default component.exports